document.addEventListener('DOMContentLoaded', () => {
    const trigger = document.querySelector('.account-trigger');
    const dropdown = document.querySelector('.account-dropdown');
    const accountLink = document.querySelector('.account-link');

    if (trigger && dropdown) {
        trigger.addEventListener('click', (e) => {

            if (window.innerWidth < 1024) {
                const headerComponentEl = document.querySelector("#header-component");
                const headerContainerEl = headerComponentEl?.querySelector(".header-new__container");

                if (headerComponentEl && headerContainerEl) {
                    headerComponentEl.style.overflow = "visible";
                    headerContainerEl.style.overflow = "visible";
                }

                if (!dropdown.contains(e.target)) {
                    e.preventDefault();
                    dropdown.classList.toggle('is-active');

                    const isExpanded = dropdown.classList.contains('is-active');

                    trigger.setAttribute('aria-expanded', isExpanded);
                }
            }
        });

        document.addEventListener('click', (e) => {
            if (window.innerWidth < 1024 && !trigger.contains(e.target)) {
                const headerComponentEl = document.querySelector("#header-component");
                const headerContainerEl = headerComponentEl?.querySelector(".header-new__container");

                if (headerComponentEl && headerContainerEl) {
                    headerComponentEl.style["overflow"] = "";
                    headerContainerEl.style["overflow"] = "";
                }

                dropdown.classList.remove('is-active');
                trigger.setAttribute('aria-expanded', 'false');
            }
        });
    }
});